const Text = ({ text, color, size, bold = false }) => (
  <div className={`text-${color} text-${size} ${bold && 'font-bold'}`}>
    {text}
  </div>
)
export default Text
